import React, { useEffect, useState, Fragment} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveCharacter } from '../../../actions/character';
import { attributeModifier } from '../../../utils/calculations';

import Modal from 'react-modal';

import CompanionEditModal from '../modals/CompanionEditModal';
import VehicleEditModal from '../modals/VehicleEditModal';

import {vehicleList} from '../../../resources/vehicles';

const CharEditExtras = ({
    item: {
        items
    },
    character: {
        character
    },
    saveCharacter
}) => {

    const{
        companions,
        vehiclesLevel,
        vehiclesExpertise,
        vehicles
    } = character;

    // Companion Modal State
    var [compModal, toggleCompModal] = useState({"open": false, "companion": {}});
    var [vehicleModal, toggleVehicleModal] = useState(false);
    var [compEditModal, toggleCompEditModal] = useState({"open": false, "companion": {}});
    var [vehicleEditModal, toggleVehicleEditModal] = useState({"open": false, "vehicle": {}});

    // Companion Form State
    var [compType, setCompType] = useState('');
    var [compName, setCompName] = useState('');
    var [creatSize, setCreatSize] = useState(0);
    var [compSpec, setCompSpec] = useState(0);
    var [creatIs, setCreatIs] = useState([]);
    var [creatNot, setCreatNot] = useState([]);
    var [compAtk, setCompAtks] = useState([]);
    var [creatEle, setCreatEle] = useState(0);

    const openCompEditModal = (comp) => e => {
        toggleCompEditModal({"open": true, "companion": comp});
    }

    const openVehicleEditModal = (vehicle) => e => {
        toggleVehicleEditModal({"open": true, "vehicle": vehicle});
    }

    const openAddVehicleModal = () => e => {
        toggleVehicleModal(true);
    }

    const removeCompanion = (comp) => (e) => {
        var newCompList = companions.filter(x => x._id !== comp._id);

        saveCharacter({
            ...character,
            companions: newCompList
        });
    }

    const removeVehicle = (vehicle) => (e) => {
        var newVehicleList = [...vehicles].filter(x => x._id !== vehicle._id);

        saveCharacter({
            ...character,
            vehicles: newVehicleList
        });
    }

    console.log(companions);

    const showCompanions = () => {

        const companionList = companions.map((comp, index) => 
        <div key={index} className="companionContainer">
            <div className="compContRow">
                <h2>{comp.name}</h2>
                <div className="compEditBut" onClick={e => openCompEditModal(comp)(e)}>Edit</div>
                <div className="compEditBut" onClick={e => removeCompanion(comp)(e)}>Remove</div>
            </div>
            <div className="compContRow">
                <div className="compAttrContainer">
                    <h3 className="text-blue">
                        Attribute Modifiers
                    </h3>
                    <div className="compAttrList">
                        <div>
                            <p>STR</p>
                            <div className="compAttrMod">{attributeModifier("STR", comp.STR)}</div>
                        </div>
                        <div>
                            <p>DEX</p>
                            <div className="compAttrMod">{attributeModifier("DEX", comp.DEX)}</div>
                        </div>
                        <div>
                            <p>CON</p>
                            <div className="compAttrMod">{attributeModifier("CON", comp.CON)}</div>
                        </div>
                        <div>
                            <p>INT</p>
                            <div className="compAttrMod">{attributeModifier("INT", comp.INT)}</div>
                        </div>
                        <div>
                            <p>WIS</p>
                            <div className="compAttrMod">{attributeModifier("WIS", comp.WIS)}</div>
                        </div>
                        <div>
                            <p>CHA</p>
                            <div className="compAttrMod">{attributeModifier("CHA", comp.CHA)}</div>
                        </div>
                    </div>
                </div>
                <div className="compAttrContainer">
                    <h3 className="text-blue">Health & Defense</h3>
                    <div className="compAttrList">
                        <div>
                            <p>HP</p>
                            <div>{comp.currentHP}/{comp.baseHP}</div>
                        </div>
                        <div>
                            <p>DIS</p>
                            <div>{comp.currentDIS}/{comp.baseDIS}</div>
                        </div>
                        <div>
                            <p>KIN</p>
                            <div>{comp.currentKIN}/{comp.baseKIN}</div>
                        </div>
                        <div>
                            <p>TARG</p>
                            <div>{comp.TARG}</div>
                        </div>
                        <div>
                            <p>EVA</p>
                            <div>{comp.EVA}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="compContRow">
                <div>
                    <h3 className="text-blue">
                        Notes
                    </h3>
                    {comp.notes}
                </div>
            </div>
        </div>
        );

        return companionList;
    }

    const openAddCompModal = () => (e) => {

        if(companions.length >= 5){
            alert('Kaleido does not support having more than 5 companions');
            return;
        }

        const newCompanion = {
            name: "",
            notes: "",
            STR: 10,
            CON: 10,
            DEX: 10,
            INT: 10,
            WIS: 10,
            CHA: 10,
            initiative: 0,
            passivePerception: 0,
            movement: 10,
            currentHP: 0,
            baseHP: 0,
            currentDIS: 0,
            baseDIS: 0,
            currentKIN: 0,
            baseKIN: 0,
            TARG: 0,
            EVA: 0,
            currentCapacity: 0,
            maxCapacity: 0,
            actions: [],
            inventory: []
        };

        toggleCompModal({"open": true, "companion": newCompanion});
    }

    const confirmCompType = (type) => (e) => {
        var nameInput = document.getElementById("compName").value
        
        if(nameInput === ''){
            alert('Please enter a name! You can change it later.');
            return;
        }

        setCompName(nameInput);
        setCompType(type);
    }

    const addCompAtk = (atk) => {

        var curAtks = compAtk;

        // Do we already have that option? Then remove.
        if(curAtks.findIndex(a => a === atk) >= 0){
            curAtks = curAtks.filter(a => a !== atk);
        } else {
            curAtks = [...curAtks, atk];
        }

        console.log(curAtks);

        setCompAtks(curAtks);
    }

    const addCreatFeat = (feat) => {

        if(creatNot.includes(feat)){
            return;
        }

        var curFeats = creatIs;

        // Do we already have that feat? Then remove.
        if(curFeats.findIndex(f => f === feat) >= 0){
            curFeats = curFeats.filter(f => f !== feat);
        } else {
            // Already have two feats chosen
            if(curFeats.length < 2){
                curFeats = [...curFeats, feat];
            }
        }

        console.log(curFeats);

        setCreatIs(curFeats);
    }

    const addCreatNot = (feat) => {

        if(creatIs.includes(feat)){
            return;
        }

        var curNots = creatNot;

        // Do we already have that feat? Then remove.
        if(curNots.findIndex(f => f === feat) >= 0){
            curNots = curNots.filter(f => f !== feat);
        } else {
            // Already have two feats chosen
            if(curNots.length < 2){
                curNots = [...curNots, feat];
            }
        }

        console.log(curNots);

        setCreatNot(curNots);
    }

    const saveComp = () => (e) => {

        if(companions.filter(x => x.name === compName).length > 0){
            alert('You cannot have multiple companions with the same name!');
            confirmCompType('')(e);
            return;
        }

        var newCompanion = {
            name: "",
            notes: "",
            STR: 10,
            CON: 10,
            DEX: 10,
            INT: 10,
            WIS: 10,
            CHA: 10,
            initiative: 0,
            passivePerception: 0,
            movement: 10,
            currentHP: 10,
            baseHP: 10,
            currentDIS: 0,
            baseDIS: 0,
            currentKIN: 0,
            baseKIN: 0,
            TARG: 10,
            EVA: 6,
            currentCapacity: 0,
            maxCapacity: 0,
            actions: [],
            inventory: []
        };

        //Check Main Attack
        if(compAtk.includes('Sharp')){
            newCompanion.actions = [...newCompanion.actions, 'Slash/Spear - Deal 2d4 damage plus DEX modifier'];
        };

        if(compAtk.includes('Heavy')){
            newCompanion.actions = [...newCompanion.actions, 'Pummel/Smash - Deal 2d4 damage plus STR modifier'];
        };

        if(compAtk.includes('Gun')){
            newCompanion.actions = [...newCompanion.actions, 'Fire Gun - Deal 2d4 damage plus DEX modifier'];
        }

        if(compAtk.includes('Melee')){
            newCompanion.actions = [...newCompanion.actions, 'Strike - Deal 2d4 damage plus STR modifier'];
        }

        // Robot functions


        // Check Attributes
        if(creatIs.includes('Brawny')){
            newCompanion.STR = 14;
            newCompanion.baseHP += 4;
            newCompanion.maxCapacity += 4 ;
        } else if(creatNot.includes('Brawny')){
            newCompanion.STR = 6;
            if(newCompanion.baseHP > 4) newCompanion.baseHP -= 4
        } else {
            newCompanion.STR = 10
        };

        if(creatIs.includes('Sturdy')){
            newCompanion.CON = 14
            newCompanion.baseHP += 4
            newCompanion.maxCapacity += 4
        } else if(creatNot.includes('Sturdy')){
            newCompanion.CON = 6
            if(newCompanion.baseHP > 4) newCompanion.baseHP -= 4
        } else {
            newCompanion.CON = 10
        };

        if(creatIs.includes('Agile')){
            newCompanion.DEX = 14
            newCompanion.initiative += 1;
            newCompanion.movement += 2;
        } else if(creatNot.includes('Agile')){
            newCompanion.DEX = 6
            newCompanion.initiative -= 1;
            newCompanion.movement -= 2;
        } else {
            newCompanion.DEX = 10
        };

        if(creatIs.includes('Cunning')){
            newCompanion.INT = 14
            newCompanion.initiative += 1;
            newCompanion.passivePerception += 2;
            newCompanion.actions = [...newCompanion.actions, 'Glean Information - Roll d20 plus INT modifier to glean information from surroundings.'];
        } else if(creatNot.includes('Cunning')){
            newCompanion.INT = 6
            newCompanion.initiative -= 1;
            newCompanion.passivePerception -= 2;
        } else {
            newCompanion.INT = 10
        };

        if(creatIs.includes('Elemental')){
            newCompanion.WIS = 14
            newCompanion.baseDIS += 5
            switch(creatEle){
                case 1:
                    newCompanion.actions = [...newCompanion.actions, 'Ignite - Set a fire in a nearby space.'];
                    if(compAtk.includes('Element')) {newCompanion.actions = [...newCompanion.actions, 'Flamethrower - Jet of flame dealing 2d8 damage, and burning for 3 turns.'];}
                    break;
                case 2:
                    newCompanion.actions = [...newCompanion.actions, 'Ignite - Set a fire in a nearby space.'];
                    if(compAtk.includes('Element')) {newCompanion.actions = [...newCompanion.actions, 'Thunderbolt - Bolt of electricity dealing 4d6 damage.'];}
                    break;
                case 3:
                    newCompanion.actions = [...newCompanion.actions, 'Displace Liquid - Manipulate a small amount of liquid.'];
                    if(compAtk.includes('Element')) {newCompanion.actions = [...newCompanion.actions, 'Jet - Cause nearby water to turn into powerful jet dealing 2d6 damage.'];}
                    break;
                case 4:
                    newCompanion.actions = [...newCompanion.actions, 'Displace Liquid - Manipulate a small amount of liquid.'];
                    if(compAtk.includes('Element')) {newCompanion.actions = [...newCompanion.actions, 'Freezing Touch - Freeze an object up to 200kg. Creatures/people roll a CON saving throw of 12+ to avoid being frozen.'];}
                    break;
                case 5:
                    newCompanion.actions = [...newCompanion.actions, 'Levitate Self - Float up to 1m higher than your current position.'];
                    if(compAtk.includes('Element')) {newCompanion.actions = [...newCompanion.actions, 'Telekinesis - Levitate and move an object up to 50kg. Can throw object as attack for 2d8 damage.'];}
                    break;
                case 6:
                    newCompanion.actions = [...newCompanion.actions, 'Renewal - Heal target for 1d6 HP.'];
                    if(compAtk.includes('Element')) {newCompanion.actions = [...newCompanion.actions, "Suggestion - Roll +WIS against the target's WIS. On success, they are compelled to perform a non-injuring action."];}
                    break;
                case 7:
                    newCompanion.actions = [...newCompanion.actions, 'Illuminate - Illuminate a 10m sphere around caster.'];
                    if(compAtk.includes('Element')) {newCompanion.actions = [...newCompanion.actions, 'Illusion - Create a silent illusion that fits in a 3m cube. Creatures must pass an Observation check of 14+ to be aware of the illusion.'];}
                    break;
                case 8:
                    newCompanion.actions = [...newCompanion.actions, "Throw Voice - Can make voice sound like it's coming from up to 40m away."];
                    if(compAtk.includes('Element')) {newCompanion.actions = [...newCompanion.actions, "Tinnitus - Target rolls CON saving throw of 14, on failure they take 1d6 mental damage for 3 turns."];}
                    break;
                default:
                    break;
            }
        } else if(creatNot.includes('Elemental')){
            newCompanion.WIS = 6
            if(newCompanion.baseDIS !== 0) newCompanion.baseDIS -= 5
        } else {
            newCompanion.WIS = 10
        };

        if(creatIs.includes('Social')){
            newCompanion.CHA = 14
            newCompanion.actions = [...newCompanion.actions, 'Calm Sentient'];
        } else if(creatNot.includes('Social')){
            newCompanion.CHA = 6
        } else {
            newCompanion.CHA = 10
        };

        //Check Creature/Robot Size
        switch(creatSize){
            case 0:
                if(compType !== 'Person'){
                    alert("You did not select a size!");
                    return;
                }
                else {
                    break;
                }
            case 1:
                newCompanion.TARG = 16;
                newCompanion.EVA = 12;
                break;
            case 2:
                newCompanion.TARG = 14;
                newCompanion.EVA = 10;
                newCompanion.baseHP += 4;
                newCompanion.maxCapacity += 4
                break;
            case 3:
                newCompanion.TARG = 12;
                newCompanion.EVA = 8;
                newCompanion.baseHP += 8;
                newCompanion.maxCapacity += 8;
                break;
            case 4:
                newCompanion.TARG = 10;
                newCompanion.EVA = 6;
                newCompanion.baseHP += 10;
                newCompanion.maxCapacity += 10;
                break;
            case 5:
                newCompanion.TARG = 8;
                newCompanion.EVA = 4;
                newCompanion.baseHP += 12;
                newCompanion.maxCapacity += 12;
                break;
            default:
                break;
        }

        //Check Person Species
        switch(compSpec){
            case 4:
                newCompanion.TARG = 13;
                break;
            case 5:
                newCompanion.TARG = 11;
                break;
            case 8:
                newCompanion.TARG = 11;
                newCompanion.baseKin = 25;
                break;
            default:
                break;
        }

        newCompanion.currentHP = newCompanion.baseHP;
        newCompanion.currentDIS = newCompanion.baseDIS;
        newCompanion.currentKIN = newCompanion.baseKIN;

        newCompanion.name = compName;

        saveCharacter({
            ...character,
            companions: [...companions, newCompanion]
        });

        closeModals();

    }

    const closeModals = () => {
        toggleCompModal({"open": false, "companion": {}});
        toggleVehicleModal(false);
        toggleCompEditModal({"open": false, "companion": {}});
        toggleVehicleEditModal({"open": false, "vehicle": {}})
        setCompType('');
        setCreatSize(0);
        setCreatIs([]);
        setCreatNot([]);
        setCompAtks([]);
        setCreatEle(0);
    }

    const addVehicle = (vehicle) => e => {
        saveCharacter({
            ...character,
            "vehicles": [...character.vehicles, vehicle]
        });

        closeModals();
    }

    const getAllVehicles = () => {

        var newVehList = vehicleList;

        if(vehiclesLevel < 50 || vehiclesExpertise === 'Pilot'){
            newVehList = vehicleList.filter(x => x.name !== "Paladin-Class Combat Mech");
        }

        if(vehiclesLevel < 30 || vehiclesExpertise === 'Pilot'){
            newVehList = vehicleList.filter(x => x.isMechSuit === false);
        }

        const vehicleEle = newVehList.map((vehicle, index) => 
            <div key={index} className="addVehicleRow">
                <h1>{vehicle.name}</h1>
                <div>
                    <h2>Description</h2>
                    <p>{vehicle.description}</p>
                </div>
                <div>
                    <h2>HP</h2>
                    <p>{vehicle.baseHP}</p>
                </div>
                <div>
                    <h2>Movement</h2>
                    <p>{vehicle.movement}</p>
                </div>
                <div>
                    <h2>Passengers</h2>
                    <p>{vehicle.maxPassengers}</p>
                </div>
                <div>
                    <h2>Capacity</h2>
                    <p>{vehicle.maxCapacity}</p>
                </div>
                <div>
                    <h2>Mod Slots</h2>
                    <p>{vehicle.modSlots}</p>
                </div>
                <div>
                    <div className="vehicleSelect" onClick={e => addVehicle(vehicle)(e)}>SELECT</div>
                </div>
            </div>
        );

        return vehicleEle;
    }

    const enterVehicle = (vehInd, act) => (e) => {

        var curVehicles = [...vehicles];

        if(curVehicles.findIndex(v => v.currentlyEntered === true) > -1){
            curVehicles[curVehicles.findIndex(v => v.currentlyEntered === true)].currentlyEntered = false;
        }

        if(act === "enter"){
            curVehicles[vehInd].currentlyEntered = true;
        }
        
        saveCharacter({
            ...character,
            "vehicles": [...curVehicles]
        });
    }

    const showVehicles = () => {

        var curVehicles = [...vehicles];

        const vehicleEle = curVehicles.map((vehicle, index) =>
            <div className="addVehicleContainer">
            {
                vehicle.isMechSuit ? 
                (
                <div key={index} className="addVehicleRow">
                    <h1>{vehicle.name}</h1>
                    <div>
                        <h2>Description</h2>
                        <p>{vehicle.description}</p>
                    </div>
                    <div>
                        <h2>HP</h2>
                        <p>{vehicle.baseHP}</p>
                    </div>
                    <div>
                        <h2>DIS</h2>
                        <p>{vehicle.baseDIS}</p>
                    </div>
                    <div>
                        <h2>KIN</h2>
                        <p>{vehicle.baseKIN}</p>
                    </div>
                    <div>
                        <h2>Movement</h2>
                        <p>{vehicle.movement}</p>
                    </div>
                    <div>
                        <h2>Capacity</h2>
                        <p>{vehicle.maxCapacity}</p>
                    </div>
                    <div>
                        <h2>Attribute Mods</h2>
                        <p>{"STR: " + vehicle.STRmod + "  DEX: " + vehicle.DEXmod + "  CON: " + vehicle.CONmod}</p>
                    </div>
                    <div>
                        {vehicle.currentlyEntered ? 
                            <div className="compEditBut" onClick={e => enterVehicle(index, "exit")(e)}>Exit</div> 
                            : <div className="compEditBut" onClick={e => enterVehicle(index, "enter")(e)}>Enter</div>
                        }
                        <div className="compEditBut" onClick={e => openVehicleEditModal(vehicle)(e)}>Edit</div>
                        <div className="compEditBut" onClick={e => removeVehicle(vehicle)(e)}>Remove</div>
                    </div>
                </div>
                ) : (
                <div key={index} className="addVehicleRow">
                    <h1>{vehicle.name}</h1>
                    <div>
                        <h2>Description</h2>
                        <p>{vehicle.description}</p>
                    </div>
                    <div>
                        <h2>HP</h2>
                        <p>{vehicle.baseHP}</p>
                    </div>
                    <div>
                        <h2>Movement</h2>
                        <p>{vehicle.movement}</p>
                    </div>
                    <div>
                        <h2>Max Passengers</h2>
                        <p>{vehicle.maxPassengers}</p>
                    </div>
                    <div>
                        <h2>Capacity</h2>
                        <p>{vehicle.maxCapacity}</p>
                    </div>
                    <div>
                        <h2>Mod Slots</h2>
                        <p>{vehicle.modSlots}</p>
                    </div>
                    <div>
                        {vehicle.currentlyEntered ? 
                            <div className="compEditBut" onClick={e => enterVehicle(index, "exit")(e)}>Exit</div> 
                            : <div className="compEditBut" onClick={e => enterVehicle(index, "enter")(e)}>Enter</div>
                        }
                        <div className="compEditBut" onClick={e => openVehicleEditModal(vehicle)(e)}>Edit</div>
                        <div className="compEditBut" onClick={e => removeVehicle(vehicle)(e)}>Remove</div>
                    </div>
                </div>
                )
            }
            
            </div>
            
            
        );

        return vehicleEle;
    }

    const onChange = e => {
        saveCharacter({
            ...character,
            [e.target.name]: e.target.value
        }, items);
    }

    return (
        <Fragment>
            <div className="char-sheet-extras-panel">
                <div className="extrasSubpanel">
                    <h1 className="lead text-blue">COMPANIONS</h1>
                    <div className="companionList">
                        <div className="addCompanionBut" onClick={e => openAddCompModal()(e)}>ADD COMPANION</div>
                        {showCompanions()}
                    </div>
                </div>
                <div className="extrasSubpanel">
                    <h1 className="lead text-blue">VEHICLES</h1>
                    <div className="companionList">
                        <div className="addCompanionBut" onClick={e => openAddVehicleModal()(e)}>ADD VEHICLE</div>
                        {showVehicles()}
                    </div>
                </div>
            </div>
            <Modal
                isOpen={compModal.open}
                onRequestClose={closeModals}
                className="companionModal"
                overlayClassName="companionModalOverlay"
            >
                <h1>Add Companion</h1>
                <div className="companionFormContainer">
                    <div className={compType === '' ? "compForm" : " compForm hidden"}>
                        <p className="promptText">What is its name?</p>
                        <div className="optionRow">
                            <input type="text" id="compName" name="compName" />
                        </div>
                        <p className="promptText">What type of companion are you adding?</p>
                        <div className="optionRow">
                            <p className="optionBut" onClick={e => confirmCompType('Creature')(e)}>Creature</p>
                            <p className="optionBut" onClick={e => confirmCompType('Person')(e)}>Person</p>
                            <p className="optionBut" onClick={e => confirmCompType('Robot')(e)}>Robot</p>
                        </div>
                    </div>
                    <div className={compType === 'Creature' ? "compForm" : "compForm hidden"}>
                        <div>
                            <p className="promptText">How Large is the Creature?</p>
                            <div className="optionRow">
                                <p className={creatSize === 1 ? "optionBut selected" : "optionBut"} onClick={e => setCreatSize(1)}>Like a Mouse</p>
                                <p className={creatSize === 2 ? "optionBut selected" : "optionBut"} onClick={e => setCreatSize(2)}>Like a Cat</p>
                                <p className={creatSize === 3 ? "optionBut selected" : "optionBut"} onClick={e => setCreatSize(3)}>Like a Wolf</p>
                                <p className={creatSize === 4 ? "optionBut selected" : "optionBut"} onClick={e => setCreatSize(4)}>Like a Horse</p>
                                <p className={creatSize === 5 ? "optionBut selected" : "optionBut"} onClick={e => setCreatSize(5)}>Like an Elephant</p>
                            </div>
                            <p className="promptText">Select Two Features That Describe the Creature:</p>
                            <div className="optionRow">
                                <p className={creatNot.includes('Brawny') ? "optionBut cancel" : creatIs.includes('Brawny') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Brawny')}>Brawny</p>
                                <p className={creatNot.includes('Agile') ? "optionBut cancel" : creatIs.includes('Agile') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Agile')}>Agile</p>
                                <p className={creatNot.includes('Sturdy') ? "optionBut cancel" : creatIs.includes('Sturdy') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Sturdy')}>Sturdy</p>
                                <p className={creatNot.includes('Cunning') ? "optionBut cancel" : creatIs.includes('Cunning') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Cunning')}>Cunning</p>
                                <p className={creatNot.includes('Elemental') ? "optionBut cancel" : creatIs.includes('Elemental') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Elemental')}>Elemental</p>
                                <p className={creatNot.includes('Social') ? "optionBut cancel" : creatIs.includes('Social') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Social')}>Social</p>
                            </div>
                            <p className="promptText">Select Two Features That <u>DO NOT</u> Describe the Creature:</p>
                            <div className="optionRow">
                                <p className={creatIs.includes('Brawny') ? "optionBut cancel" : creatNot.includes('Brawny') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Brawny')}>Brawny</p>
                                <p className={creatIs.includes('Agile') ? "optionBut cancel" : creatNot.includes('Agile') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Agile')}>Agile</p>
                                <p className={creatIs.includes('Sturdy') ? "optionBut cancel" : creatNot.includes('Sturdy') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Sturdy')}>Sturdy</p>
                                <p className={creatIs.includes('Cunning') ? "optionBut cancel" : creatNot.includes('Cunning') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Cunning')}>Cunning</p>
                                <p className={creatIs.includes('Elemental') ? "optionBut cancel" : creatNot.includes('Elemental') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Elemental')}>Elemental</p>
                                <p className={creatIs.includes('Social') ? "optionBut cancel" : creatNot.includes('Social') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Social')}>Social</p>
                            </div>
                            <p className={creatIs.includes('Elemental') ? "promptText" : "hidden"}>Which Type of Energy Empowers the Creature?</p>
                            <div className={creatIs.includes('Elemental') ? "optionRow" : "hidden"}>
                                <p className={creatEle === 1 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(1)}>Fire</p>
                                <p className={creatEle === 2 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(2)}>Lightning</p>
                                <p className={creatEle === 3 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(3)}>Water</p>
                                <p className={creatEle === 4 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(4)}>Ice</p>
                                <p className={creatEle === 5 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(5)}>Gravity</p>
                                <p className={creatEle === 6 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(6)}>Psychic</p>
                                <p className={creatEle === 7 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(7)}>Light</p>
                                <p className={creatEle === 8 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(8)}>Sound</p>
                            </div>
                            <p className="promptText">How will this creature try to defend itself? (Select All That Apply)</p>
                            <div className="optionRow">
                                <p className={compAtk.includes('Sharp') ? "optionBut selected" : "optionBut"} onClick={e => addCompAtk('Sharp')}>Something Sharp (Claws, Stinger, etc.)</p>
                                <p className={compAtk.includes('Heavy') ? "optionBut selected" : "optionBut"} onClick={e => addCompAtk('Heavy')}>Something Heavy (Headbutt, Club Tail, etc.)</p>
                                <p className={!creatIs.includes('Elemental') ? "hidden" : compAtk.includes('Element') ? "optionBut selected" : "optionBut"} onClick={e => addCompAtk('Element')}>Controlling Elements</p>
                            </div>
                            <div className="optionRow">
                                <div className="confirmCreatBut" onClick={e => saveComp()(e)}>Confirm</div>
                            </div>
                            
                        </div>
                    </div>
                    <div className={compType === 'Person' ? "compForm" : "compForm hidden"}>
                        <div>
                            <p className="promptText">What species is this person?</p>
                            <div className="optionRow">
                                <p className={compSpec === 1 ? "optionBut selected" : "optionBut"} onClick={e => setCompSpec(1)}>Human</p>
                                <p className={compSpec === 2 ? "optionBut selected" : "optionBut"} onClick={e => setCompSpec(2)}>Cyborg</p>
                                <p className={compSpec === 3 ? "optionBut selected" : "optionBut"} onClick={e => setCompSpec(3)}>Quexi</p>
                                <p className={compSpec === 4 ? "optionBut selected" : "optionBut"} onClick={e => setCompSpec(4)}>Aerzha</p>
                                <p className={compSpec === 5 ? "optionBut selected" : "optionBut"} onClick={e => setCompSpec(5)}>Muhmin</p>
                                <p className={compSpec === 5 ? "optionBut selected" : "optionBut"} onClick={e => setCompSpec(6)}>Ts'tsen</p>
                                <p className={compSpec === 5 ? "optionBut selected" : "optionBut"} onClick={e => setCompSpec(7)}>Veith</p>
                                <p className={compSpec === 5 ? "optionBut selected" : "optionBut"} onClick={e => setCompSpec(8)}>Koz'Aid</p>
                            </div>
                            <p className="promptText">Select Two Features That Describe this Person:</p>
                            <div className="optionRow">
                                <p className={creatNot.includes('Brawny') ? "optionBut cancel" : creatIs.includes('Brawny') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Brawny')}>Brawny</p>
                                <p className={creatNot.includes('Agile') ? "optionBut cancel" : creatIs.includes('Agile') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Agile')}>Agile</p>
                                <p className={creatNot.includes('Sturdy') ? "optionBut cancel" : creatIs.includes('Sturdy') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Sturdy')}>Sturdy</p>
                                <p className={creatNot.includes('Cunning') ? "optionBut cancel" : creatIs.includes('Cunning') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Cunning')}>Cunning</p>
                                <p className={creatNot.includes('Elemental') ? "optionBut cancel" : creatIs.includes('Elemental') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Elemental')}>Elemental</p>
                                <p className={creatNot.includes('Social') ? "optionBut cancel" : creatIs.includes('Social') ? "optionBut confirm" : "optionBut"} onClick={e => addCreatFeat('Social')}>Social</p>
                            </div>
                            <p className="promptText">Select Two Features That <u>DO NOT</u> Describe this Person:</p>
                            <div className="optionRow">
                                <p className={creatIs.includes('Brawny') ? "optionBut cancel" : creatNot.includes('Brawny') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Brawny')}>Brawny</p>
                                <p className={creatIs.includes('Agile') ? "optionBut cancel" : creatNot.includes('Agile') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Agile')}>Agile</p>
                                <p className={creatIs.includes('Sturdy') ? "optionBut cancel" : creatNot.includes('Sturdy') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Sturdy')}>Sturdy</p>
                                <p className={creatIs.includes('Cunning') ? "optionBut cancel" : creatNot.includes('Cunning') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Cunning')}>Cunning</p>
                                <p className={creatIs.includes('Elemental') ? "optionBut cancel" : creatNot.includes('Elemental') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Elemental')}>Elemental</p>
                                <p className={creatIs.includes('Social') ? "optionBut cancel" : creatNot.includes('Social') ? "optionBut neg" : "optionBut"} onClick={e => addCreatNot('Social')}>Social</p>
                            </div>
                            <p className={creatIs.includes('Elemental') ? "promptText" : "hidden"}>Which Type of Energy Empowers Them?</p>
                            <div className={creatIs.includes('Elemental') ? "optionRow" : "hidden"}>
                                <p className={creatEle === 1 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(1)}>Fire</p>
                                <p className={creatEle === 2 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(2)}>Lightning</p>
                                <p className={creatEle === 3 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(3)}>Water</p>
                                <p className={creatEle === 4 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(4)}>Ice</p>
                                <p className={creatEle === 5 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(5)}>Gravity</p>
                                <p className={creatEle === 6 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(6)}>Psychic</p>
                                <p className={creatEle === 7 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(7)}>Light</p>
                                <p className={creatEle === 8 ? "optionBut selected" : "optionBut"} onClick={e => setCreatEle(8)}>Sound</p>
                            </div>
                            <p className="promptText">How will this person defend themselves? (Select all that apply)</p>
                            <div className="optionRow">
                                <p className={compAtk.includes('Gun') ? "optionBut selected" : "optionBut"} onClick={e => addCompAtk('Gun')}>Gun</p>
                                <p className={compAtk.includes('Melee') ? "optionBut selected" : "optionBut"} onClick={e => addCompAtk('Melee')}>Melee</p>
                                <p className={!creatIs.includes('Elemental') ? "hidden" : compAtk.includes('Element') ? "optionBut selected" : "optionBut"} onClick={e => addCompAtk('Element')}>Controlling Elements</p>
                            </div>
                            <div className="optionRow">
                                <div className="confirmCreatBut" onClick={e => saveComp()(e)}>Confirm</div>
                            </div>
                        </div>
                    </div>
                    <div className={compType === 'Robot' ? "compForm" : "compForm hidden"}>
                    <div>
                        <p className="promptText">How Large is the Robot?</p>
                            <div className="optionRow">
                                <p className={creatSize === 1 ? "optionBut selected" : "optionBut"} onClick={e => setCreatSize(1)}>Like a Mouse</p>
                                <p className={creatSize === 2 ? "optionBut selected" : "optionBut"} onClick={e => setCreatSize(2)}>Like a Cat</p>
                                <p className={creatSize === 3 ? "optionBut selected" : "optionBut"} onClick={e => setCreatSize(3)}>Like a Wolf</p>
                                <p className={creatSize === 4 ? "optionBut selected" : "optionBut"} onClick={e => setCreatSize(4)}>Like a Horse</p>
                                <p className={creatSize === 5 ? "optionBut selected" : "optionBut"} onClick={e => setCreatSize(5)}>Like an Elephant</p>
                            </div>
                            <p className="promptText">What is the Robot's primary function?</p>
                            <div className="optionRow">
                                <p className={compAtk.includes('Combat') ? "optionBut selected" : "optionBut"} onClick={e => {addCompAtk('Combat'); setCreatIs('Brawny'); setCreatNot('Social');}}>Combat</p>
                                <p className={compAtk.includes('Scouting') ? "optionBut selected" : "optionBut"} onClick={e => {addCompAtk('Scouting'); setCreatIs('Agile'); setCreatNot('Elemental');}}>Scouting</p>
                                <p className={compAtk.includes('Hauling') ? "optionBut selected" : "optionBut"} onClick={e => {addCompAtk('Hauling'); setCreatIs('Sturdy'); setCreatNot('Cunning');}}>Hauling</p>
                                <p className={compAtk.includes('Investigation') ? "optionBut selected" : "optionBut"} onClick={e => {addCompAtk('Investigation'); setCreatIs('Cunning'); setCreatNot('Sturdy');}}>Investigation</p>
                                <p className={compAtk.includes('Repair/Hacking') ? "optionBut selected" : "optionBut"} onClick={e => {addCompAtk('Repair/Hacking'); setCreatIs('Elemental'); setCreatNot('Brawny')}}>Repair/Hacking</p>
                                <p className={compAtk.includes('Translation') ? "optionBut selected" : "optionBut"} onClick={e => {addCompAtk('Translation'); setCreatIs('Social'); setCreatNot('Agile')}}>Translation</p>
                            </div>
                            <p className="promptText">What form of combat does this Robot utilize?</p>
                            <div className="optionRow">
                                <p className={compAtk.includes('Gun') ? "optionBut selected" : "optionBut"} onClick={e => addCompAtk('Gun')}>Gun</p>
                                <p className={compAtk.includes('Melee') ? "optionBut selected" : "optionBut"} onClick={e => addCompAtk('Melee')}>Melee</p>
                            </div>
                            <div className="optionRow">
                                <div className="confirmCreatBut" onClick={e => saveComp()(e)}>Confirm</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                isOpen={vehicleModal}
                onRequestClose={closeModals}
                className="vehicleModal"
                overlayClassName="vehicleModalOverlay"
            >
                <h1>Add Vehicle</h1>
                <div className="addVehicleContainer">
                {getAllVehicles()}
                </div>
            </Modal>
            <Modal
                isOpen={compEditModal.open}
                onRequestClose={closeModals}
                className="companionModal"
                overlayClassName="companionModalOverlay"
            >
                <CompanionEditModal selectedComp={compEditModal.companion} closeModal={closeModals} />
            </Modal>
            <Modal
                isOpen={vehicleEditModal.open}
                onRequestClose={closeModals}
                className="companionModal"
                overlayClassName="companionModalOverlay"
            >
                <VehicleEditModal selectedVehicle={vehicleEditModal.vehicle} closeModal={closeModals} />
            </Modal>
        </Fragment>
    )
}

CharEditExtras.propTypes = {
    character: PropTypes.object.isRequired,
    saveCharacter: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    character: state.character,
    item: state.item
});

export default connect(mapStateToProps, {saveCharacter})(CharEditExtras);
